/**
 * @module utils/dateHelpers
 */

import { format } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'

export const DATE_FORMAT = 'MMMM dd, yyyy'

export const getSecondsFromTimeStamp = (timeStamp = null) => {
  return typeof timeStamp === 'number' ? Math.floor(timeStamp / 1000) : 0
}

export const getMinutesFromTimeStamp = (timeStamp = null) => {
  return typeof timeStamp === 'number' ? Math.floor(timeStamp / 60000) : 0
}

export const getHoursFromTimeStamp = (timeStamp = null) => {
  return typeof timeStamp === 'number' ? Math.floor(timeStamp / 3600000) : 0
}

export const seconds = (value) => (Number(value) || 0) * 1000

export const minutes = (value) => (Number(value) || 0) * 60000

export const hours = (value) => (Number(value) || 0) * 3600000

export const getStringFromSeconds = (secs) => {
  if (Number.isNaN(secs) || secs === undefined || secs === null) {
    return 'unknown'
  }
  const mins = Math.floor(secs / 60)
  let remainder = Math.floor(secs % 60)
  if (remainder < 10) {
    remainder = '0' + remainder
  }
  return mins + ':' + remainder
}

export const getMonthDisplay = (month) => {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ]
  if (month < months.length && month >= 0) {
    return months[month]
  } else {
    return ''
  }
}

export const getDayDisplay = (day) => {
  if (day < 10) {
    return `0${day}`
  } else {
    return day
  }
}

export const formatMilliSeconds = (input) => {
  const date = new Date(input)
  const year = date.getFullYear()
  const month = date.getMonth()
  const day = date.getDate()
  return `${getDayDisplay(day)}-${getMonthDisplay(month)}-${year}`
}

export const formatMilliSecondsWithoutTimezone = (input) => {
  const date = new Date(input)
  const year = date.getFullYear()
  const month = date.getMonth()
  const day = date.getDate()
  return `${getDayDisplay(day)}-${getMonthDisplay(month)}-${year}`
}

export const formatSeconds = (input) => {
  const date = new Date(input * 1000)
  const year = date.getFullYear()
  const month = date.getMonth()
  const day = date.getDate()
  return `${getDayDisplay(day)}-${getMonthDisplay(month)}-${year}`
}

export const formatSecondsWithoutTimezone = (input) => {
  const date = new Date(input * 1000)
  const year = date.getUTCFullYear()
  const month = date.getUTCMonth()
  const day = date.getUTCDate()
  return `${getDayDisplay(day)}-${getMonthDisplay(month)}-${year}`
}

export const formatDateWithTimeZoneFromSeconds = (value) => {
  const dateInMilliseconds = value * 1000
  const date = new Date(dateInMilliseconds)

  const zonedDate = utcToZonedTime(date, 'Etc/UTC')

  return format(zonedDate, DATE_FORMAT, { timeZone: 'Etc/UTC' })
}
